module.exports = "div.right {\n    float: right;\n}\ntd.right {\n    text-align: right;\n}\ndiv.separator {\n    margin-top: 20px;\n}\na {\n    text-decoration: underline;\n    cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/profile.component.css
// module id = ./src/app/profile/profile.component.css
// module chunks = main